module.exports = __webpack_public_path__ + "img/index-english.ff0e9618.jpg";